import { Component, ElementRef, ViewChild } from '@angular/core';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';

@Component({
  selector: 'app-all-move-mail-list',
  templateUrl: './all-move-mail-list.component.html',
  styleUrls: ['./all-move-mail-list.component.scss']
})
export class AllMoveMailListComponent {
  isGlobal: boolean = true;
  public routerUrl = urlRoutes;
  @ViewChild('dialogContent') dialogContent: ElementRef;

  onScrollTop() {
    //this.dialogContent?.nativeElement?.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
